import _ from 'lodash';
import { auth } from '@/shared/lib';
import { LIST_ROLES_ADMIN_OR_SALES, LIST_ROLES_CLINIC } from '@/shared/config';

/**
 * Decides whether the signed-in user holds any role a screen demands. Rejects an empty or non-array input, then matches the list against the admin-or-sales role set when auth reports an admin or sales user and against the clinic role set otherwise.
 *
 * @param roles - Roles accepted by the caller.
 * @returns True when the user holds one of the accepted roles.
 */
const handleCheckRoles = (roles: any) => {
  if (_.isEmpty(roles) || !_.isArray(roles)) {
    return false;
  }

  const isValid = auth.isAdminOrSales()
    ? _.some(LIST_ROLES_ADMIN_OR_SALES, (roleSales) => _.includes(roles, roleSales))
    : _.some(LIST_ROLES_CLINIC, (roleSales) => _.includes(roles, roleSales));
  return isValid;
};

/**
 * Reports whether a user's role list contains a specific role. Defaults the role list to empty and delegates the membership test to lodash includes.
 *
 * @param userRoles - Roles assigned to the user.
 * @param roleString - Role name to look for.
 * @returns True when the role is present in the user's roles.
 */
const isIncludeRole = (userRoles: any, roleString: any) => _.includes(userRoles, roleString);

export { handleCheckRoles, isIncludeRole };
